import React from "react";
// import { Users, Settings, Target } from "tabler-icons-react";
import { Award, Users, Settings, Target, Beaker } from "tabler-icons-react";

export default function Client() {
  return (
    <div>
      <div className="text-center mb-12">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          Our Valued Clients
        </h3>
        <p className="text-lg text-gray-600">
          Serving dairy farms, cooperatives, and industries across Nepal and
          beyond
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
          <div className="bg-blue-500 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
            <Users className="w-8 h-8 text-white" />
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-4">
            Dairy Cooperatives
          </h4>
          <p className="text-gray-600 mb-4">
            Supporting over 600+ dairy cooperatives across Nepal with reliable
            milk testing solutions.
          </p>
          <div className="bg-white p-4 rounded-lg">
            <span className="text-sm font-semibold text-blue-600">
              600+ Active Partners
            </span>
          </div>
        </div>

        <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
          <div className="bg-green-500 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
            <Settings className="w-8 h-8 text-white" />
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-4">
            Industrial Clients
          </h4>
          <p className="text-gray-600 mb-4">
            Providing advanced milk analysis solutions to major dairy processing
            industries and manufacturing plants.
          </p>
          <div className="bg-white p-4 rounded-lg">
            <span className="text-sm font-semibold text-green-600">
              10+ Industries
            </span>
          </div>
        </div>

        <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
          <div className="bg-orange-500 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
            <Target className="w-8 h-8 text-white" />
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-4">
            Private Farms
          </h4>
          <p className="text-gray-600 mb-4">
            Empowering individual dairy farmers with affordable and accurate
            milk quality testing equipment.
          </p>
          <div className="bg-white p-4 rounded-lg">
            <span className="text-sm font-semibold text-orange-600">
              100+ Farmers
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
